import { isFeuilleDeMatchFull } from "../../../../../components/Live/utils/feuilleMatch.js"
import { EMPTY_PLAYER } from "../../../../../components/Live/utils/helpers.js"

export const COACH_PLAYER = (team) => ({lastname : 'l\'entraineur de '+team.name})

export const getPlayer = (id, match, team) => {
    const {homeHolders, homeSubstitutes, awayHolders, awaySubstitutes} = match

    let allPlayers = isFeuilleDeMatchFull(match) ? [...homeHolders, ...homeSubstitutes, ...awayHolders, ...awaySubstitutes] : [...match.homeTeam.players, ...match.awayTeam.players]
    let foundedPlayer = id==='coach' ? COACH_PLAYER(team) : allPlayers.find(p => p._id === id) ?? null;

    if (!foundedPlayer) {
        const matchTeams = [match.homeTeam, match.awayTeam]
        //find player with id in all match teams players
        for (let i = 0; i < matchTeams.length; i++) {
            const teamPlayers = matchTeams[i]?.players;
            foundedPlayer = teamPlayers?.find(p => p?._id === id) || null
        }
    }

     return foundedPlayer || EMPTY_PLAYER
}

export const getTeam = (id, match) => {
    const {homeTeam, awayTeam} = match

    return [homeTeam, awayTeam].find(t => t._id === id)
}